export interface CataleanWishlistConfig {
  remote: boolean;
}
